export const APP_MODE_STANDARD='STANDARD';
export const HP_PLUS_PLAN_CARD='HP_PLUS_PLAN_CARD'